<template>
  <ExamReport
    @created="onReportCreated"
    @goRepeat="goRepeat"
    @goAnalysis="goAnalysis"
    reportType="special"
  >
    <template v-slot:bread="{ detail }">
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPoint' }">专项练习</router-link>
        <span class="slash">/</span>
        <span>{{ detail.title }}</span>
        <span class="slash">/</span>
        <span class="current">答题报告</span>
      </div>
    </template>
  </ExamReport>
</template>
<script>
import ExamReport from "./components/ExamReport";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamSpecialReport",
  components: {
    ExamReport,
    ExamIndexBread,
  },
  data() {
    return {
      detail: {},
      specialId: this.$route.query.specialId,
    };
  },
  methods: {
    onReportCreated(detail) {
      this.detail = detail;
    },
    async goRepeat() {
      let data = await this.$http.post("/api/app/practice/report", {
        type: 5,
        practise_id: this.specialId,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamSpecialDo",
        query: {
          id: data,
          specialName: this.detail.title,
          specialId: this.specialId,
        },
      });
    },
    goAnalysis(type) {
      this.$router.push({
        name: "ExamSpecialAnalysis",
        query: {
          id: this.$route.query.id,
          type: type,
          specialName: this.detail.title,
          specialId: this.specialId,
        },
      });
    },
  },
};
</script>
